module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "coming-soon",
    attrs: {
      "src": _vm.$t('blog.coming_soon')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-444e3e54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Blog.vue
// module id = 114
// module chunks = 0